export const photoCapturePhotoUploadReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { workItemStatus: action.payload.workItemStatus });
};
//# sourceMappingURL=photoCapturePhotoUploadReducer.js.map